// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectGuard } from './redirect.guard';
import { EmptyComponent } from './views/pages/empty/empty.component';

const routes: Routes = [

  {
    path: '_admin/index.php',
    canActivate: [RedirectGuard],
    component: EmptyComponent // a placeholder, won't load due to redirect
  },

  {
    path: '',
    canActivate: [RedirectGuard], // <-- Attach the guard
    loadChildren: () =>
      import('app/views/layouts/layouts.module').then(m => m.LayoutsModule) 
  },
  {path: '**', redirectTo: 'error', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
